var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-component'),_c('div',{staticClass:"px-2 py-2 w-full"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('create-user',{attrs:{"edited-user":_vm.editedUser,"redirect-to-users":true}})],1)])])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('h3',{staticClass:"mb-0",staticStyle:{"text-transform":"capitalize"}},[_vm._v("Add User")])])
}]

export { render, staticRenderFns }